import "./tabs.scss"
import $ from "jquery"

class Tabs {

    WrapTabs
    WrapSection

    constructor ( wrapTabs , wrapSection ) {

        if ( $( wrapTabs ).length != 0 ){ 
            this.WrapTabs = wrapTabs
            this.WrapSection = wrapSection

            $(window).on( 'click' , e => {
                $(this.WrapTabs).removeClass( 'open' )
            })

            $( this.WrapTabs ).on( 'click' , 'a.menu' , e => {
                e.stopPropagation()
                this.changeTab( $(e.currentTarget).attr( 'href' ) )
                $(this.WrapTabs).removeClass( 'open' )
                return false;
            })

            $( this.WrapTabs ).on( 'click' , 'a.open-tabs' , e => {
                e.stopPropagation()
                $(this.WrapTabs).addClass('open')
            })



            window.onload = (event) => {
                if( document.location.hash ){
                    this.changeTab( document.location.hash )
                    return false
                }else if( ! $( this.WrapTabs ).find( '.active' ).length ){
                    let firstTab = $( this.WrapTabs ).find( 'li:first-child a' ).attr( 'href' )
                    this.changeTab( firstTab )
                }
            }

            window.onpopstate = (event) => {                
                this.changeTab( document.location.hash )
            }
        }

    }


    changeTab ( tab ) {
        $( this.WrapTabs ).find( 'a' ).removeClass( 'active' )
        $( this.WrapTabs ).find( 'a[href="'+ tab +'"]' ).addClass( 'active' )
        $( this.WrapSection ).removeClass( 'active' )
        $( tab ).addClass( 'active' )        
    }

}

export { Tabs }